module.exports = __webpack_public_path__ + "static/FAMILY_052004.a578384d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/FAMILY_052004.gif
// module id = 495
// module chunks = 8418805283199